'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (amount, currencyCode) {
  return _I18n2.default.text('i18n.numberRepresentation.numberWithCurrencyCode', {
    amountNumberValue: amount,
    currencyCode: currencyCode
  });
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.441/js/utils/formatCurrencyWithCode.js
// module id = 518
// module chunks = 171